import styled from 'styled-components';

export const OpenQuestionnairesDetailsWrapper = styled.div`
  height: 100%;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 4px;
  .ant-btn-dangerous {
    border-color: ${({ theme }) => theme.colors.tone.red};
    & > span {
      color: ${({ theme }) => theme.colors.tone.red};
    }
  }
  .ant-btn-dangerous.ant-btn-primary:hover,
  .ant-btn-dangerous.ant-btn-primary:focus {
    background-color: transparent;
    border-color: ${({ theme }) => theme.colors.tone.red};
  }
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 32px;
`;

export const InfoWrapperTitle = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
`;


export const InfoElement = styled.div`
  display: flex;
  margin-bottom: 14px;
  align-items: center;
  & > div:first-child {
    margin-right: 8px;
  }
  & > div:last-child {
    max-width: 211px;
    word-wrap: break-word;
  }
`;

export const InfoBlock = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 48px
`;

export const InfoBlockContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const ElementContainer = styled.div`
  margin-bottom: 16px;
  & > div:first-child {
    margin-bottom: 12px;
  }
`;
